<main class="layout-profile-sidebar">
  <header class="breadcrumb">
    <button (click)="back()" class="button tertiary d-none d-sm-flex">
      <span class="icon icon-arrow-left"></span>
      <ng-container i18n="@@marketplace.memberDetail.return">Zurück</ng-container>
    </button>
  </header>
  <article class="layout-ignore">
    <h1 class="sr-only" i18n="sr-only@@marketplace.memberDetail.title">Profildetails</h1>
    <aside class="sidebar">
      <nav>
        <h2 class="sr-only" i18n="sr-only@@marketplace.memberDetail.sidebar">Seitenleiste</h2>
        <ul class="navbar-nav vertical">
          <li [class.link-active]="(activeFragment | async) === null || (activeFragment | async) === 'profile'"
            class="nav-item">
            <a [replaceUrl]="true" [routerLink]='"."' class="nav-link" fragment="profile"
            i18n="@@marketplace.memberDetail.link.profile">Profil</a>
          </li>
          @if (relation) {
            <li [class.link-active]="(activeFragment | async) === 'messages'" class="nav-item">
              <a [replaceUrl]="true" [routerLink]='"."' class="nav-link" fragment="messages"
              i18n="@@marketplace.memberDetail.link.news">Nachrichten</a>
            </li>
          }
        </ul>
      </nav>

      @if (member && !myProfile) {
        <div class="sidebar-section d-none d-sm-flex">
          <h2 class="sr-only" i18n="sr-only@@marketplace.memberDetail.titleActions">Aktionen</h2>
          <ul class="navbar-nav vertical">
            <li class="nav-item">
              <a [href]="emailReportAbuse"
                class="nav-link"
                i18n="@@marketplace.memberDetail.link.reportAbuse"
                >
                            Missbrauch melden
                        </a>
            </li>
          </ul>
        </div>
      }
    </aside>
    @if (member) {
      <div class="layout-ignore">
        <section class="summary" id="profile">
          <div class="summary">
            <figure aria-hidden="true" class="avatar">
              <img [src]="member.profilePicture.path" alt="">
            </figure>
            <div class="summary-content">
              <div class="header">
                <h2 class="heading">{{ companionName }}</h2>
                <app-employment-state [relation]="relation"></app-employment-state>
              </div>
              <h3 class="sr-only" i18n="sr-only@@marketplace.memberDetail.profile">Profil</h3>
              @if (member.lastSeenOn) {
                <div class="last-online">
                  <span class="last-online__dot" [class.last-online__dot--active]="isOnlineToday"></span>
                  {{ member.lastSeenOn | relativeTime }}
                </div>
              }
              <p>
                @if (offer.workPerimeter) {
                  <span>{{ offer.workPerimeter.zip }} {{ offer.workPerimeter.place }}</span>
                }
                @if (offer.workPerimeter && offer.workPerimeter.radiusM !== 0) {
                  <span>,
                    <ng-container
                      i18n="@@marketplace.memberDetail.maxDistanceToWork">Arbeitsweg maximal {{ offer.workPerimeter.radiusM / 1000 }}
                    km</ng-container>
                  </span>
                }
              </p>
              @if (member.aboutMe) {
                <p>
                  {{ member.aboutMe }}
                </p>
              }
              @if (offer.description) {
                <p>
                  {{ offer.description }}
                </p>
              }
              <app-tag-list [status]="tagStatus" [tags]="offer.assistanceServices"></app-tag-list>
            </div>
          </div>
        </section>
        <div class="content">
          <section>
            @if (member.hasPrivilegedData) {
              <app-message i18n="@@marketplace.memberDetail.hasPrivilegedData">
                        {{ member.firstName }} hat Ihnen die Kontaktdaten freigegeben.
                    </app-message>
            }
            <table class="details-table">
              @if (member.hasPrivilegedData) {
                <tr class="private-details">
                  <th i18n="@@marketplace.memberDetail.telefon">Telefon</th>
                  <td><span aria-hidden="true" class="icon icon-phone"></span>{{ member.phoneNumber }}
                </td>
              </tr>
              <tr class="private-details">
                <th i18n="@@marketplace.memberDetail.email">E-Mail</th>
                <td>
                  <span aria-hidden="true" class="icon icon-mail"></span>
                  <a [href]="member.emailAddress | mailto"
                  style="line-break: anywhere;">{{ member.emailAddress }}</a>
                </td>
              </tr>
            }
            <tr class="private-details">
              @if (auth.isRecipient) {
                <th i18n="@@marketplace.memberDetail.documents">Dokumente</th>
              }
              @if (auth.isGiver) {
                <th i18n="@@marketplace.memberDetail.dossier">Dossier</th>
              }
              <td>
                <ul>
                  @for (document of member.documents; track document) {
                    <li>
                      <span aria-hidden="true" class="icon icon-folder"></span>
                      <a (click)="downloadDocument(document, $event)"
                      [href]="documentUrl(document)">{{ document.name }}</a>
                    </li>
                  }
                </ul>
              </td>
            </tr>
            <tr>
              <th i18n="@@marketplace.memberDetail.age">Alter</th>
              <td>{{ member.age }}</td>
            </tr>
            <tr>
              <th i18n="@@marketplace.memberDetail.nativeLanguage">Muttersprache</th>
              <td>{{ member.nativeLanguage | stringifySelectionTags }}</td>
            </tr>
            <tr>
              <th i18n="@@marketplace.memberDetail.languages">Sprachen</th>
              <td>{{ memberLanguages | stringifySelectionTags }}</td>
            </tr>
            <tr>
              <th i18n="@@marketplace.memberDetail.mobility">Mobilität</th>
              <td>{{ offer.mobility | stringifySelectionTags }}</td>
            </tr>
            <tr>
              <th i18n="@@marketplace.memberDetail.assistantDoctor">Assistenzart</th>
              <td>{{ offer.compensation | stringifySelectionTags }}</td>
            </tr>
          </table>
        </section>
        @if (relation) {
          <app-relation-status [companionName]="companionName" [relation]="relation"></app-relation-status>
          <app-team-status [companionName]="companionName" [relation]="relation"></app-team-status>
          <app-multi-messages [companionName]="companionName" [relation]="relation"></app-multi-messages>
        }
        @if (member && !myProfile) {
          <section class="actions form-group d-sm-none">
            <h3 class="sr-only" i18n="sr-only@@marketplace.memberDetail.titleActions">Aktionen</h3>
            <a [href]="emailReportAbuse" i18n="@@marketplace.memberDetail.link.reportAbuse">
                        Missbrauch melden
                    </a>
          </section>
        }
      </div>
    </div>
  }
</article>
</main>
